import type { DialogueCondition } from '@/core/types/contracts';
import type { WeatherState } from '@/core/types';

/** What a condition can look at. `hasFlag` means "reached" (flags are a prefix of the route). */
export interface ConditionEnv {
  hasFlag(flag: string): boolean;
  hasMark(mark: string): boolean;
  weather(): string;
}

/**
 * Evaluates a node condition. All present clauses must hold (AND). A missing condition is true.
 * Pure and Phaser-free so it is unit-testable.
 */
export function evalCondition(cond: DialogueCondition | undefined, env: ConditionEnv): boolean {
  if (!cond) return true;
  if (cond.hasFlag !== undefined && !env.hasFlag(cond.hasFlag)) return false;
  if (cond.notFlag !== undefined && env.hasFlag(cond.notFlag)) return false;
  if (cond.hasMark !== undefined && !env.hasMark(cond.hasMark)) return false;
  if (cond.notMark !== undefined && env.hasMark(cond.notMark)) return false;
  if (cond.weather && cond.weather.length > 0 && !cond.weather.includes(env.weather() as WeatherState)) return false;
  return true;
}
